import { units } from '../../../common/js/config/constants';
import { builder } from '../../../common/js/config/index';
import { unmarshaller as expandBtnConfig } from './expand-buton-config';

// Here this config will be merge with the default video config
export const unmarshaller = {
  closeBtn: builder.holder({
    displayAfter: builder.number('close_btn_display_after', {
      defaultValue: 8,
      unit: units.seconds
    }),
    position: builder.string('close_btn_position', {
      of: ['right', 'left'],
      possibleValues: [
        {
          name: 'Left',
          value: 'left'
        },
        {
          name: 'Right',
          value: 'right'
        }
      ],
      defaultValue: 'right',
      label: 'Close button position',
      description: 'Position of the close button'
    })
  }),
  shouldCallMraidCloseOnClick: builder.boolean(
    'should_call_mraid_close_on_click',
    {
      defaultValue: true
    }
  ),
  controls: builder.holder({
    layout: builder.holder({
      canDisplayResponsiveControls: builder.boolean(
        'can_display_responsive_controls',
        { defaultValue: true }
      )
    })
  }),
  ...expandBtnConfig
};
